export const termsTranslation = {
  message: 'Criando uma conta, eu concordo com os <link1 /> e <link2 />.',
  user_terms: 'Termos de Uso',
  privacy_policy: 'Política de Privacidade',
  upload: 'Solte os arquivos aqui ou clique',
  browse: 'navegue',
  machine: 'pela sua máquina'
};
